import { useState, type ReactNode } from "react";

const CORRECT_PASSWORD = "SQRS2006";

interface PasswordGateProps {
  children: ReactNode;
  returnPath?: string;
}

export default function PasswordGate({ children, returnPath = "/blog" }: PasswordGateProps) {
  const [authenticated, setAuthenticated] = useState(false);
  const [input, setInput] = useState("");
  const [error, setError] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (input === CORRECT_PASSWORD) {
      setAuthenticated(true);
      setError(false);
    } else {
      setError(true);
      setInput("");
    }
  };

  if (!authenticated) {
    return (
      <main className="min-h-screen flex items-center justify-center pt-24 md:pt-28 pb-16">
        <div className="w-full px-4 sm:px-6 max-w-md mx-auto">
          <div className="bg-background-50 rounded-lg border border-background-200/70 p-8 md:p-10 text-center">
            <div className="w-14 h-14 mx-auto mb-5 rounded-full bg-background-100 flex items-center justify-center">
              <i className="ri-lock-line text-2xl text-foreground-600" />
            </div>
            <h2 className="font-heading text-2xl font-light text-foreground-950 mb-2">
              Admin access
            </h2>
            <p className="font-body text-sm text-foreground-500 mb-6">
              Enter the password to manage blog posts.
            </p>

            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <input
                  type="password"
                  value={input}
                  onChange={(e) => {
                    setInput(e.target.value);
                    setError(false);
                  }}
                  placeholder="Enter password"
                  autoFocus
                  className={`w-full px-4 py-3 bg-background-50 border rounded-md font-body text-sm text-foreground-900 placeholder-foreground-400 focus:outline-none focus:ring-2 focus:border-transparent transition-all duration-300 text-center ${
                    error
                      ? "border-accent-400 focus:ring-accent-400"
                      : "border-background-300 focus:ring-primary-400"
                  }`}
                />
                {error && (
                  <p className="mt-2 font-body text-xs text-accent-600">
                    Incorrect password. Please try again.
                  </p>
                )}
              </div>

              <button
                type="submit"
                disabled={!input.trim()}
                className="w-full bg-primary-500 text-background-50 font-body text-sm font-medium px-5 py-2.5 rounded-md hover:bg-primary-600 transition-all duration-300 disabled:opacity-40 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
              >
                Unlock
              </button>
            </form>

            <a
              href={returnPath}
              className="inline-block mt-5 font-body text-xs text-foreground-400 hover:text-foreground-600 transition-colors duration-200"
            >
              &larr; Back to blog
            </a>
          </div>
        </div>
      </main>
    );
  }

  return <>{children}</>;
}